import { ChangeDetectionStrategy, Component, forwardRef, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { TextareaInputComponent } from '../../../form-components/textarea-input/textarea-input.component';

@Component({
  selector: 'app-review-textarea-input',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './review-textarea-input.component.html',
  styleUrls: ['./review-textarea-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ReviewTextareaInputComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReviewTextareaInputComponent extends TextareaInputComponent {
  @Input() hintText?: string;

  public setDisabledState(isDisabled: boolean): void {
    super.setDisabledState?.(isDisabled);
    this.cdr.markForCheck();
  }

  public writeValue(value: string | null): void {
    super.writeValue(value);
    this.cdr.markForCheck();
  }
}
